
const GetImarcDropdownReducer = (state = { type: 'LOADING_IMARC_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_IMARC_DROPDOWN_ACTION':
            return action
        case 'RESET_IMARC_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetImarcSecondaryDropdownReducer = (state = { type: 'LOADING_IMARC_COUNTRY_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_IMARC_COUNTRY_DROPDOWN_ACTION':
            return action
        case 'RESET_IMARC_COUNTRY_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetImarcDetailReducer = (state = { type: 'LOADING_IMARC_DETAIL_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_IMARC_DETAIL_ACTION':
            return action
        case 'RESET_IMARC_DETAIL_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
export {
    GetImarcDropdownReducer,
    GetImarcSecondaryDropdownReducer,
    GetImarcDetailReducer
}